<template>
    <div>
        <div class="content">
            <div class="cont-list">
                <span class="list">{{
                    this.parentRoute.menuName + "-" + this.route.menuName
                }}</span>
                <span class="masge">当前共有{{ total }}条{{ this.route.menuName }}</span>
            </div>

            <el-tabs v-model="activeName" @tab-click="handleClick">
                <el-tab-pane label="单独赋码" name="first">
                    <div class="header">
                        <div class="left">
                            <el-input v-model="query.traceNo" style="width: 20vw" @change="getData"
                                placeholder="扫UDI追溯码快速定位"></el-input>
                        </div>
                        <div class="right">
                            <el-button type="primary" class="btn primary" @click="batchCoding">批量赋码</el-button>
                            <el-dropdown @command="batchPrintChange" style="margin: 10px 10px">
                                <el-button type="primary" size="small">
                                    批量打印<i class="el-icon-arrow-down el-icon--right"></i>
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <!-- <el-dropdown-item command="1">RFID打印</el-dropdown-item> -->
                                    <el-dropdown-item command="2">普通打印</el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                    </div>
                    <el-table ref="multipleTable" border v-loading="loading" :data="tableData" :max-height="tableHeight"
                        style="width: 100%" @selection-change="handleSelectionChange" row-key="index" stripe
                        :header-cell-style="{ background: '#DDEBFF' }">
                        <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
                        </el-table-column>
                        <el-table-column prop="supplierProductNo" width="170" label="供应商产品编码"
                            show-overflow-tooltip></el-table-column>
                        <el-table-column prop="productName" width="150" label="产品名称"
                            show-overflow-tooltip></el-table-column>
                        <el-table-column prop="specName" width="100" label="规格/型号"
                            show-overflow-tooltip></el-table-column>
                        <el-table-column prop="bookStock" width="80" label="数量"></el-table-column>
                        <el-table-column prop="minUnit" width="80" label="最小单位"></el-table-column>
                        <el-table-column prop="price" width="80" label="采购价"></el-table-column>

                        <el-table-column prop="mainNo" width="100" label="主条码" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="traceNo" width="100" label="溯源码" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="minTagCode" min-width="180" label="标签码"></el-table-column>
                        <el-table-column prop="batch" width="100" label="批号" show-overflow-tooltip></el-table-column>
                        <el-table-column prop="serialNo" width="100" label="序列号"
                            show-overflow-tooltip></el-table-column>
                        <el-table-column prop="manufactureDate" width="120" label="生产日期">
                            <template slot-scope="scope">{{
                                parseTime(new Date(scope.row.manufactureDate), "{y}-{m}-{d}")
                            }}</template>
                        </el-table-column>
                        <el-table-column prop="validityDate" width="120" label="有效期">
                            <template slot-scope="scope">{{
                                parseTime(new Date(scope.row.validityDate), "{y}-{m}-{d}")
                            }}</template>
                        </el-table-column>
                        <el-table-column prop="printTimes" label="打印次数" width="100"></el-table-column>
                        <el-table-column fixed="right" prop="operation" label="操作" width="150">
                            <template slot-scope="scope">
                                <el-button type="text" size="small" v-if="scope.row.hasTagCode == 0" v-preventReClick
                                    @click="codingEvt(scope.row)" class="color-blue">赋码</el-button>
                                <!--  -->
                                <el-button  v-if="scope.row.hasTagCode == 1" type="text" size="small" v-preventReClick class="color-blue"
                                    @click="print(scope.row)">RFID打印</el-button>
                                <!--  -->
                                <el-button  v-if="scope.row.hasTagCode == 1"  type="text" size="small" @click="print1(scope.row)"
                                    class="margin-left20 color-blue">普通打印</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <div class="pagination">
                        <el-pagination background layout="sizes, prev, pager, next, jumper"
                            :page-sizes="[10, 20, 50, 100, 200, 500, 1000]" :page-size="query.pageSize"
                            @size-change="handleSizeChange" :current-page="query.pageIndex" :total="total"
                            @current-change="changePage">
                        </el-pagination>
                    </div>
                </el-tab-pane>
                <el-tab-pane label="打包赋码" name="second">
                    <div class="edit-card">
                        <el-row>
                            <el-col :span="12">
                                <div style="width: 100%; display: flex">
                                    <div class="start-label" />
                                    <span style="flex: 6" class="text">待打包明细</span>
                                    <div>
                                        <el-button style="margin-top: 5px" class="btn primary" type="primary"
                                            size="small" v-preventReClick @click="packEvt">打包</el-button>
                                    </div>
                                </div>
                                <el-table :data="toBePackagedData" v-loading="loading" border
                                    style="width: auto; margin: 10px 0px" height="300" stripe
                                    :header-cell-style="{ background: '#DDEBFF' }" row-key="id">
                                    <el-table-column type="index" width="50" label="序号">
                                    </el-table-column>
                                    <el-table-column prop="productName" label="产品" min-width="180"></el-table-column>
                                    <el-table-column prop="specName" label="规格型号" width="180"></el-table-column>
                                    <el-table-column prop="number" label="可打包数量" width="140"></el-table-column>
                                    <el-table-column label="本次打包数量" prop="thisNumber" width="180">
                                        <template slot-scope="scope">
                                            <el-input-number size="small" v-model="scope.row.thisNumber"
                                                @change="(res) => numberEvt(res, scope.row)" :min="0"
                                                :max="scope.row.number" label="请输入内容"></el-input-number>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="manufacturerName" label="生产厂家" width="150"></el-table-column>
                                    <el-table-column prop="unit" label="最小单位" width="120"></el-table-column>
                                    <el-table-column prop="packSpec" label="包装规格" min-width="120"></el-table-column>
                                    <el-table-column prop="price" label="单价" width="180"></el-table-column>
                                    <el-table-column prop="batch" label="批次号" width="180"></el-table-column>
                                    <el-table-column prop="validityDate" label="有效期" width="180"></el-table-column>
                                    <el-table-column prop="serialNo" label="序列号" width="180"></el-table-column>
                                    <el-table-column prop="supplierName" label="供应商" width="180"></el-table-column>
                                </el-table>
                            </el-col>
                            <el-col :span="12">
                                <div style="width: 88%; display: flex">
                                    <div class="start-label" />
                                    <span class="text">打包预览</span>
                                </div>
                                <el-table :data="previewPackagedData" border style="width: auto; margin: 12px 0px"
                                    height="300" stripe :header-cell-style="{ background: '#DDEBFF' }" row-key="id">
                                    <el-table-column type="index" width="50" label="序号">
                                    </el-table-column>
                                    <el-table-column prop="productName" label="产品" min-width="180"></el-table-column>
                                    <el-table-column prop="specName" label="规格型号" width="180"></el-table-column>
                                    <el-table-column prop="manufacturerName" label="生产厂家" width="180"></el-table-column>
                                    <el-table-column prop="number" label="本包数量" width="180"></el-table-column>
                                    <el-table-column prop="unit" label="最小单位" width="180"></el-table-column>
                                    <el-table-column prop="price" label="单价" width="180"></el-table-column>
                                    <el-table-column prop="batch" label="批次号" width="180"></el-table-column>
                                    <el-table-column prop="amount" label="金额小计" width="180"></el-table-column>
                                </el-table>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="edit-card">
                        <el-row>
                            <div style="width: 100%; display: flex">
                                <div class="start-label" />
                                <span style="flex:6" class="text">已打包</span>

                                    <el-dropdown @command="batchPrintChange"  style="margin: 10px 10px;">
                                        <el-button type="primary" size="small">
                                          批量打印<i class="el-icon-arrow-down el-icon--right"></i>
                                        </el-button>
                                        <el-dropdown-menu slot="dropdown">
                                          <el-dropdown-item command="1">RFID打印</el-dropdown-item>
                                          <el-dropdown-item command="2">普通打印</el-dropdown-item>
                                        </el-dropdown-menu>
                                      </el-dropdown>
                              
                            </div>
                            <el-table :data="packagedData" v-loading="loading" border
                                style="width: auto; margin: 10px 0px" height="300" stripe
                                :header-cell-style="{ background: '#DDEBFF' }" :span-method="objectSpanMethod"
                                row-key="id" @selection-change="handleSelectionChange1" >
                                <el-table-column align="center" :reserve-selection="true" type="selection" fixed width="55">
                                </el-table-column>
                                <el-table-column type="index" width="50" label="序号"> </el-table-column>
                                <el-table-column prop="minTagCode" label="包标签码" min-width="200"></el-table-column>
                                <el-table-column prop="productName" label="产品" min-width="180"></el-table-column>
                                <el-table-column prop="specName" label="规格型号" width="180"></el-table-column>
                                <el-table-column prop="manufacturerName" label="生产厂家" width="180"></el-table-column>
                                <el-table-column prop="number" label="数量" width="180"></el-table-column>
                                <el-table-column prop="unit" label="最小单位" width="180"></el-table-column>
                                <el-table-column prop="price" label="单价" width="180"></el-table-column>
                                <el-table-column prop="batch" label="批次号" width="180"></el-table-column>
                                <el-table-column prop="amount" label="小计" width="180"></el-table-column>
                                <el-table-column prop="printTimes" label="打印次数" width="180"></el-table-column>
                                <el-table-column fixed="right" prop="operation" label="操作" width="220">
                                    <template slot-scope="scope">
                                        <el-button type="text" v-preventReClick  @click="print(scope.row)" class="color-blue" >RFID打印</el-button>
                                        <el-button type="text" v-preventReClick @click="print1(scope.row)"
                                            class="color-blue">普通打印</el-button>
                                        <el-button type="text" v-preventReClick @click="cancelCoed(scope.row)"
                                            class="color-blue">作废</el-button>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </el-row>
                    </div>
                </el-tab-pane>
            </el-tabs>
        </div>
        <div slot="footer" class="footer-bottom">
            <el-button class="btn primary" type="primary" style="margin-right: 10px" @click="goBackEvt">返回</el-button>
        </div>
    </div>
</template>

<script>
import {
    GetInventoryStockSingleList,
    GenerateInventoryStockSingleTagCode,
    GetInventoryStockUnPackedList,
    GenerateInventoryStockPackTagCode,
    GetInventoryStockPackedList,
    CancelCode,
    GetTagCodePrintData,
    GetTagCodeRfidPrintData
} from "@/api";
import GetDataMixin from "@/mixin/getData-mixin.js";
import GetDataSpdMixin from "@/mixin/getData-spd-mixin.js";
import BaseListMixin from "@/mixin/baseList-mixin.js";
import { Debounce } from "@/utils/utils";
export default {
    mixins: [GetDataMixin, GetDataSpdMixin, BaseListMixin],

    data() {
        return {
            GetDatasAction: GetInventoryStockSingleList,
            activeName: "first",
            previewPackagedData: [],
            packagedData: [],
            toBePackagedData: [],
            tagCodeGenTempId: "",
            multipleSelection1:[],
            ids1:[ ],
            multiple1: true,
        
        };
    },
    methods: {
        onmessage(e) {
            // window.console.log("收到消息啦:" + e.data);
            var data = JSON.parse(e.data);
            if (data.Successful) {
                this.$my_message("打印成功", "success");
            } else {
                this.$my_message("打印失败：" + data.Message, "error");
            }
        },
        onopen() {
            console.log("连接成功了哦");
        },

        handleClick:Debounce(function(tab, event){
            this.loading = true;
            this.query.pageIndex = 1;
            if (tab.name == "first") {
                this.getData();
            } else {
                this.getPackData();
            }
        }),
       
        getPackData() {
            GetInventoryStockUnPackedList(this.query).then((res) => {
                this.toBePackagedData = res.returnData.data;
                this.loading = false;
            });
            GetInventoryStockPackedList(this.query).then((res) => {
                this.packagedData = res.returnData.data;
                this.loading = false;
            })
        },
        packEvt() {
            let data = this.previewPackagedData.map((res) => {
                res.tagCodeGenTempId = this.query.tagCodeGenTempId;
                return res;
            });
            GenerateInventoryStockPackTagCode({ tagCodeList: data }).then(res => {
                this.$message.success('打包成功')
                this.previewPackagedData = []
                this.getPackData()
            })
        },
        numberEvt(res, row) {
            if ((this.previewPackagedData.length === 0 || this.previewPackagedData.filter(res => res.id == row.id).length === 0) && res != 0) {
                let data = {
                    ...row,
                    amount: res * row.price,
                    number: res
                }
                this.previewPackagedData.push(data)
            } else {
                this.previewPackagedData.forEach((val, index) => {
                    if (val.id == row.id) {
                        if (res == 0 || res == undefined) {
                            this.previewPackagedData.splice(index, 1)
                        } else {
                            this.$set(val, 'amount', res * val.price)
                            this.$set(val, 'number', res)
                        }
                    }
                });
            }
            this.$forceUpdate()
        },
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            if (columnIndex === 0 || columnIndex == 2|| columnIndex == 12||columnIndex == 11) {
                if (
                    rowIndex > 0 &&
                    this.packagedData[rowIndex].minTagCode ===
                    this.packagedData[rowIndex - 1].minTagCode
                ) {
                    return { rowspan: 0, colspan: 0 };
                } else {
                    let rowspan = 1;
                    for (let i = rowIndex + 1; i < this.packagedData.length; i++) {
                        if (this.packagedData[i].minTagCode === row.minTagCode) {
                            rowspan++;
                        } else {
                            break;
                        }
                    }
                    return { rowspan, colspan: 1 };
                }
            }
            return { rowspan: 1, colspan: 1 };
        },

          // 作废
    cancelCoed(row){
      this.$confirm('是否作废该标签？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        CancelCode({minTagCode:row.minTagCode}).then(res=>{
          if(res.successful){
            this.getPackData()
            this.$message({
              type: 'success',
              message: '作废成功!'
            });
          }
        })
     
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消作废'
        });
      });
    },
        codingEvt(row) {
            GenerateInventoryStockSingleTagCode({
                ids: [row.id],
                tagCodeGenTempId: this.tagCodeGenTempId,
            }).then((res) => {
                this.$my_message("赋码成功", "success");
                this.getData();
            });
        },


        handleSelectionChange1 (selection) {
            // 按照minTagCode去重
            const uniqueSelection = selection.reduce((acc, current) => {
                if (!acc.some(item => item.minTagCode === current.minTagCode)) {
                    acc.push(current);
                }
                return acc;
            }, []);
            
            this.multipleSelection1 = uniqueSelection;
            this.ids1 = uniqueSelection.map((item) => item.id);
            this.multiple1 = !uniqueSelection.length; 
        },
        batchCoding() {
            if (!this.multipleSelection) {
                this.$my_message("请选择要赋码的数据", "warning");
                return;
            }
            
            // 新增验证逻辑
            const hasCodedItems = this.multipleSelection.some(item => item.hasTagCode !== 0);
            if (hasCodedItems) {
                this.$my_message("只能选择未赋码的数据进行批量赋码", "warning");
                return;
            }
            
            let ids = this.multipleSelection.map((res) => res.id);
            GenerateInventoryStockSingleTagCode({
                ids,
                tagCodeGenTempId: this.tagCodeGenTempId,
            }).then((res) => {
                this.$my_message("赋码成功", "success");
                this.$refs.multipleTable.clearSelection();
                this.getData();
            });
        },
        //普通打印
        print1(row) {
            return new Promise((resolve, reject) => {
                let data = {
                    tagCode: row.minTagCode,
                    isSingle: row.isRfid == 1 ? 1 : 0,
                };
                return GetTagCodePrintData(data).then((res) => {
                    var result = res.returnData;
                    this.$set(row, "printTimes", (row.printTimes??0) + 1);                    
                    var printData = this.printDataConvert(result.printData);
                    this.sendPrintMessage(JSON.stringify(printData));
                    resolve(res.returnData);
                });
            });
        },
        print(row, notRefresh) {
            return new Promise((resolve, reject) => {
                return GetTagCodeRfidPrintData({
                    tagCode: row.minTagCode,
                }).then((res) => {
                    var action = "PrintSingle";
                    if (row.isRfid != 1) {
                        action = "PrintPack";
                    }
                      if(this.system_setting.RFIDTempSite){
                    this.$my_message("打印成功", "success");
                        resolve(res.returnData);
                         this.$set(row, "printTimes", (row.printTimes??0) + 1);
                        return
                    }
                    var data = {
                        Action: action,
                        Content: res.returnData,
                    };
                    this.$set(row, "printTimes", (row.printTimes??0) + 1);
                    this.rfidSocketApi.sendSock(data);
                    resolve(res.returnData);
                });
            });
        },
        batchPrintChange(num) {
            this.batchPrintType = num;
            let arr = this.activeName == 'first'? this.multipleSelection : this.multipleSelection1            
            if (arr.length == 0) {
                this.$my_message("请选择要打印的数据", "warning");
                return;
            }
            // 新增验证逻辑
            const hasCodedItems = arr.some(item => item.hasTagCode == 0);
            if (hasCodedItems) {
                this.$my_message("只能选择已赋码的数据进行批量打印", "warning");
                return;
            }
            const map = new Map();
            for (let i = 0; i < arr.length; i++) {
                if ("minTagCode" in arr[i]) {
                    arr[i].minTagCode = arr[i].minTagCode;
                }
            }
            this.newArr = arr.filter(
                (key) => !map.has(key.minTagCode) && map.set(key.no, 1)
            );

            this.printForeach(0);
        },

        printForeach(i) {
            if (i != this.newArr.length) {
                let notRefresh = true;
                if (i == this.newArr.length - 1) {
                    notRefresh = false;
                }
                if (this.batchPrintType == 1) {
                    this.print(this.newArr[i], notRefresh).then((res) => {
                        i++;
                        setTimeout(() => {
                            this.printForeach(i);
                        }, 1000);
                    });
                } else {
                    this.print1(this.newArr[i], notRefresh).then((res) => {
                        i++;
                        setTimeout(() => {
                            this.printForeach(i);
                        }, 1000);
                    });
                }
            } else {
                if (this.$refs.customTable) {
                    this.$refs.customTable.callChildMethod().clearSelection();
                }
                if (this.$refs.multipleTable) {
                    this.$refs.multipleTable.clearSelection();
                }
                // this.getData()
            }
        },
        goBackEvt() {
            this.query.pageIndex = 1;
            this.routePushWithParams("/stock", this.query);
        },
    },
    mounted() {
        this.tagCodeGenTempId = this.query.tagCodeGenTempId;
        this.rfidSocketApi.init(this.onmessage, this.onopen);
        if (this.$refs.multipleTable) {
            this.$nextTick(() => {
                this.tableHeight =
                    this.$refs.multipleTable.$parent.$parent.$parent.$el.clientHeight -
                    this.$refs.multipleTable.$el.offsetTop -
                    20;
            })
        }
    },
    beforeDestroy() {
        this.rfidSocketApi.clearBingMethods();
    },

    created() {
        // console.log(this.$route.query,123);
        // this.route = this.$route.query;
        // this.parentRoute = this.$route.params;
    },
};
</script>

<style lang="scss" scoped>
/deep/.el-badge__content.is-fixed {
    top: 10px !important;
    right: 12px !important;
}
</style>
